import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  private sidenav: MatSidenav;
  /**
  *@method setSidenav sets side nav
  **/

  public setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }
  /**
  *@method open opens side nav
  **/

  public open() {
    return this.sidenav.open();
  }

  /**
  *@method close closes side nav
  **/

  public close() {
    return this.sidenav.close();
  }
  /**
  *@method toggle toggles side nav
  **/

  public toggle(): void {
    this.sidenav.toggle();
  }
}
